import { defineComponent as _defineComponent } from 'vue'
import UserInfoDataService from "@/services/UserInfoDataService";
import { store } from "@/store/store";
import ResponseData from "@/types/ResponseData";
import { ref } from "vue";
import Navigation from "../../NavigationContainer.vue";
import UserLinkNavigation from "../../UserLinkNavigationContainer.vue";
import Alert from "../parts/Alert.vue";
import { useI18n } from "vue3-i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const cognitoUserName = store.getters.cognitoUserName;
const givenName = ref(store.getters.givenName);
const familyName = ref(store.getters.familyName);
const oldgivenName = ref(store.getters.givenName);
const oldfamilyName = ref(store.getters.familyName);
const oldDepartment = ref(store.getters.department);
const stationCode = store.getters.stationCode;
const companyName = store.getters.companyName;
const email = store.getters.email;
const title = ref(store.getters.title);
const department = ref(store.getters.department);
const i18n = useI18n();
const alertMessage = ref("null");
const alertState = ref("neutral");
const givenNameError = ref("");
const familyNameError = ref("");
const beforeChangeFName = ref(store.getters.familyName);
const beforeChangeGName = ref(store.getters.givenName);

const checkSpecialCharacter = (userName) => {
  var re = /[`!@#$%^&*()_+\-={};':"\\|,.<>/?＿~]/;
  return re.test(userName);
};

const isInputOK = () => {
  var isInputOK = true;
  //[Given Name]のチェック
  if (givenName.value.trim() == "") {
    givenNameError.value = i18n.t("alt015");
    isInputOK = false;
  } else if (checkSpecialCharacter(givenName.value.trim())) {
    givenNameError.value = i18n.t("alt016");
    isInputOK = false;
  } else {
    givenNameError.value = "";
  }

  //[Family Name]のチェック
  if (familyName.value.trim() == "") {
    familyNameError.value = i18n.t("alt017");
    isInputOK = false;
  } else if (checkSpecialCharacter(familyName.value.trim())) {
    familyNameError.value = i18n.t("alt018");
    isInputOK = false;
  } else {
    familyNameError.value = "";
  }
  return isInputOK;
}

/** ユーザー情報を更新する関数 */
const updateUserInfo = () => {
  alertMessage.value = "null";
  alertState.value = "neutral";
  if(!isInputOK()){
    return;
  }

  const userValue = store.state.oriLoginUserInfo[0];
  const data = {
    userId: cognitoUserName,
    stationCode: stationCode,
    givenName: givenName.value,
    familyName: familyName.value,
    dept: department.value,
    email: email,
    title: title.value,
    department: department.value,
    oldDepartment: oldDepartment.value,
    loginUserId: userValue?.userId?? cognitoUserName,
  };

  UserInfoDataService.UpdateUserInfo(data)
    .then((response: ResponseData) => {
      alertMessage.value = i18n.t("suc005");
      alertState.value = "success";
      store.dispatch("setGivenName", response.data["givenName"]);
      store.dispatch("setFamilyName", response.data["familyName"]);
      store.dispatch("setTitle", response.data["title"]);
      store.dispatch("setDepartment", response.data["department"]);

      if (
        oldgivenName.value !== givenName.value ||
        oldfamilyName.value !== familyName.value
      ) {
        // 2023/05/18 MDCR 修正 start(同じstationCodeに違うUserIdがあるため、stationCodeの条件追加対応)
        const data1 = { 
          userId: cognitoUserName,
          stationCode: stationCode,
          targetScreen: "UserInfo"
         };
        // 2023/05/18 MDCR 修正 end
        UserInfoDataService.getEmployeeIDInfo(data1)
          .then((response: ResponseData) => {
            if (response.data.length != 0) {
              const cscfileData1 = {
                // 2023/04/24 MDCR 修正 start(actionFlg変更)
                // actionFlg: 5,
                actionFlg: 2,
                // 2023/04/24 MDCR 修正 end(actionFlg変更)
                userID: cognitoUserName,
                LName: response.data[0].familyName,
                FName: response.data[0].givenName,
                employeeID: response.data[0].employeeNumber,
                mail: email,
                companyName: companyName,
                stationCode: stationCode,
              };
              UserInfoDataService.send_authenticationID(cscfileData1)
                .then((response: ResponseData) => {
                  alertMessage.value = i18n.t("suc005");
                  alertState.value = "success";
                })
                .catch((e: Error) => {
                  alertMessage.value = i18n.t("err063");
                  alertState.value = "error";
                  console.log(e);
                });
            } else {
              alertMessage.value = i18n.t("err020");
              alertState.value = "error";
            }
          })
          .catch((e: Error) => {
            console.log(e);
            alertMessage.value = i18n.t("err020");
            alertState.value = "error";
          });
      }
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err024");
      alertState.value = "error";
      console.log(e);
    });
};

const txtOnKeyDown = (event: { target: { value: any; }; }) => {
  var re = /^[A-Za-z ]+$/;
  beforeChangeFName.value = re.test(familyName.value)? familyName.value: beforeChangeFName.value;
  beforeChangeGName.value = re.test(givenName.value)? givenName.value: beforeChangeGName.value;
}
const checkAlphabet = (event: { target: { value: any; }; }) => {
  var re = /^[A-Za-z ]+$/;
  if(!re.test(event.target.value) && event.target.value != ""){
    familyName.value = beforeChangeFName.value;
    givenName.value = beforeChangeGName.value;
  }
  return;
}

const __returned__ = { cognitoUserName, givenName, familyName, oldgivenName, oldfamilyName, oldDepartment, stationCode, companyName, email, title, department, i18n, alertMessage, alertState, givenNameError, familyNameError, beforeChangeFName, beforeChangeGName, checkSpecialCharacter, isInputOK, updateUserInfo, txtOnKeyDown, checkAlphabet, Navigation, UserLinkNavigation, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})